import { DropDownOptions } from '../../../types';
import {
    GenericBladeAPI,
    GenericBladeDynamicContentInfo,
    GenericBladeParsedDataType,
    NodePayload,
} from '../genericBladeTypes';

type MapGenericBladeParsedApiData = {
    dynamicContent: GenericBladeDynamicContentInfo,
    api?: GenericBladeAPI
}

export default ({
    dynamicContent,
    api,
}: MapGenericBladeParsedApiData) => {
    const apiData = Object.entries(api ?? {}).reduce(
        (result, [key, value]) => {
            // If dropdown options is in API, extract the options and selectedvalue
            if (typeof value === 'object') {
                // If generic blade api data is of type "object" there can be only 2 possibilities.
                // Either it will be an array of dropdown values. In this case, the selected value will be picked up in else case.
                // Or it will be an object containing an array of dropdown values and selectedValue
                const entryValue = Object.entries(value).find(([innerKey]) =>
                    innerKey.toLowerCase().includes('value'),
                );
                const resultValue = entryValue ? entryValue[1] : undefined;
                const entryOptions = Object.entries(value).find(([innerKey]) =>
                    innerKey.toLowerCase().includes('options'),
                )?.[1] as DropDownOptions<string>[] | undefined;

                const resultOptions = entryOptions?.map(({ key: optionKey, label: optionLabel, value: optionValue }) => ({
                    label: optionKey || optionLabel || '', value: optionValue,
                }));

                return {
                    ...result,
                    [key]: {
                        value: resultValue as NodePayload | undefined,
                        options: resultOptions as DropDownOptions<string>[] | undefined,
                    },
                };
            } else {
                // If dropdown options are AEM and the AEM is set from API, get the Value from API and Options from AEM
                if (Object.keys(dynamicContent).includes(key)) {
                    const options = Object.entries(dynamicContent[key] ?? {}).find(([aemKey]) => aemKey.toLowerCase().includes('options'));

                    const dropdownOptions = options && options[1]
                        ? Object.values(options[1] as DropDownOptions<string>[]).map(({ key: aemKey, label, value: aemValue }) => (
                            { label: aemKey || label || '', value: aemValue }
                        ))
                        : undefined;

                    return {
                        ...result,
                        [key]: {
                            value: (value as NodePayload) ?? '',
                            options: dropdownOptions as DropDownOptions<string>[] | undefined,
                        },
                    };
                } else if (
                    Object.keys(dynamicContent).includes(
                        key.replace('Value', '') || key.replace('Amount', ''),
                    )
                ) {
                    return {
                        ...result,
                        [key.replace('Value', '') || key.replace('Amount', '')]: { value: (value as NodePayload) ?? '' },
                    } as GenericBladeParsedDataType;
                } else {
                    return {
                        ...result,
                        [key]: { value: (value as NodePayload) ?? '' },
                    } as GenericBladeParsedDataType;
                }
            }
        },
    {} as GenericBladeParsedDataType,
    );

    return apiData;
};
